import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList,
  HostListener
} from '@angular/core';
import { TotemService } from '../totem.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import Keyboard from 'simple-keyboard';
import { ActivatedRoute } from '@angular/router';
import { Categoria } from './categoria';
import { Subcategoria } from './subcategoria';
import { Tienda } from './tienda';
import { viewClassName } from '@angular/compiler';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tiendas',
  templateUrl: './tiendas.component.html',
  styleUrls: ['./tiendas.component.css']
})
export class TiendasComponent implements OnInit, AfterViewInit {
  keyboard: Keyboard;
  commonKeyboardOptions = {
    onKeyPress: (button: string) => this.onKeyPress(button)
  };
  tiendas: Array<Tienda>;
  tiendasfil: Array<Tienda>;
  subcategorias: Array<Subcategoria> = [];
  tiendasprimarias = [];


  otherTiendasresult: Array<Tienda>;
  contienen: Array<Tienda>;
  contienentags: Array<Tienda>;

  comienzan = true;
  contienentienda = false;
  tienetag = false;

  subcategoriReales = [];
  CategoriasReales = [];
  value: string;
  categoriactual = '';
  teclado = false;
  menu = true;
  claseletra = 'letter-bar show';
  sinletra = true;
  conletra = true;
  inputteclado = '';
  @ViewChild('inputbusqueda', { static: false }) inputbusqueda: ElementRef;
  nombreant: string;
  todasLasTiendas: Array<Tienda>;
  options = { autoHide: false, scrollbarMinSize: 100 };
  @ViewChildren('listatiendahtml') listatiendahtml: QueryList<ElementRef>;
  imagenTienda = 'assets/placeholders/logo-tiendas.jpg';
  listaletras = [];
  tiendaslistas = false;
  categoriaslistas = false;

  constructor(
    private totemService: TotemService,
    private activatedRoute: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}
  async ngOnInit() {
    window.addEventListener('scroll', this.scrollevent, true);
    try {
      const id = Number(this.activatedRoute.snapshot.params.id);
      console.log('el id', id);
      const tiendas = await this.totemService.getTiendas().toPromise();
      this.tiendasprimarias = tiendas.map((tienda: any) => new Tienda(tienda));
      this.tiendas = this.tiendasprimarias.slice();
      const tiendaestado = [];
      for (const tiendaest of this.tiendas) {
         if (tiendaest.estado.toString() === 'Habilitado' ||
           tiendaest.estado.toString() === 'Proximamente' || tiendaest.estado.toString() === 'Regresamos-Pronto') {
          if (environment.tiendaimagen) {
            if (!tiendaest.logo || tiendaest.logo === '') {
              tiendaest.logo = this.imagenTienda;
            }
            tiendaestado.push(tiendaest);
          } else {
            if (tiendaest.logo || tiendaest.logo !== '') {
              tiendaestado.push(tiendaest);
            }
          }
        }
      }
      this.tiendasfil = tiendaestado;
      this.otherTiendasresult = tiendaestado;
      this.todasLasTiendas = await this.sortByKey(this.tiendasfil);
      this.tiendaslistas = true;

      const items = await this.totemService.getCategorias().toPromise();
      const categorias = items.map(item => new Categoria(item));

      for (const categoria of categorias) {
        const subcategorias = categoria.subcategorias.filter(subcategoria =>
          id ? subcategoria.id === id : true
        );
        for (const subcategoria of subcategorias) {
          subcategoria.tiendas = this.tiendasfil.filter((tienda: Tienda) => {
            return tienda.subcategorias.find(idSubcategoria => {
              return idSubcategoria === subcategoria.id;
            });
          });
          this.subcategorias.push(subcategoria);
        }
      }
      for (const subcat of this.subcategorias) {
        if (subcat.tiendas.length !== 0) {
          const nombre = subcat.nombre.toLowerCase();
          subcat.nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
          this.subcategoriReales.push(subcat);
        }
      }
      this.categoriaslistas = true;
      this.ordenarletras(this.todasLasTiendas);
    } catch (err) {
      console.error(err);
    }
  }

  ngAfterViewInit(): void {
    this.keyboard = new Keyboard({
      ...this.commonKeyboardOptions,
      layout: {
        default: [
          '1 2 3 4 5 6 7 8 9 0 {bksp}',
          'q w e r t y u i o p',
          'a s d f g h j k l ñ',
          'z x c v b n m & ` {Cancelar}',
          '{space}'
        ]
      },
      display: {
        '{Cancelar}': ' Cancelar ',
        '{bksp}': ' ⌫',
        '{space}': '<i class="material-icons"></i>'
      },
      useButtonTag: true,
      onChange: input => this.onChange(input)
    });
  }

  public desplegarteclado() {
    this.value = '';
    this.keyboard.setInput('');
    this.filterTiendas('');
    this.teclado = !this.teclado;
    this.menu = !this.menu;
  }
  public onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value);
  }
  onKeyPress = (button: string) => {
    if (button === '{Cancelar}') {
      setTimeout(() => {
        this.desplegarteclado();
      }, 100);
    }
  }
  private onChange(input: string) {
    this.cancelartimer();
    if (this.teclado === true) {
      this.value = input;
      this.filterTiendas(input);
    }
  }
  private filterTiendas(input: string) {
    input = input.toUpperCase();
    if (!input || input === '') {
      this.comienzan = true;
      this.contienentienda = false;
      this.tienetag = false;
      this.contienen = [];
      this.contienentags = [];
      return (this.otherTiendasresult = this.tiendasfil);
    }
    let tiendasfiltrar = this.tiendasfil.slice();

    // filtrar si empiezan
    this.otherTiendasresult = tiendasfiltrar.filter((tienda: Tienda) => {
      const nombretienda = this.eliminarDiacriticos(tienda.nombre);
      return nombretienda.toUpperCase().indexOf(input) === 0;
    });
    if (this.otherTiendasresult.length > 0) {
      this.comienzan = true;
    } else {
      this.comienzan = false;
    }
    tiendasfiltrar = this.eliminartienda(tiendasfiltrar, this.otherTiendasresult);
    // filtrar si contienen
    this.contienen = tiendasfiltrar.filter((tienda: Tienda) => {
      const nombretienda = this.eliminarDiacriticos(tienda.nombre);
      return nombretienda.toUpperCase().includes(input) === true;
    });
    if (this.contienen.length > 0) {
      this.contienentienda = true;
    } else {
      this.contienentienda = false;
    }
    tiendasfiltrar = this.eliminartienda(tiendasfiltrar, this.contienen);
    // filtrar por tags
    if (input.length > 1) {
      this.contienentags = tiendasfiltrar.filter((tienda: Tienda) => {
        const mastiendas = tienda.tags.filter((tagstiendas) => {
          const tag = this.eliminarDiacriticos(tagstiendas);
          return tag.toUpperCase().includes(input) === true;
        });
        if (mastiendas.length !== 0) {
          const sindidactricos = [];
          for (const tagsin of mastiendas) {
            sindidactricos.push(this.eliminarDiacriticos(tagsin));
          }
          tienda.tags = sindidactricos;
          return tienda;
        }
      });
    }
    if (this.contienentags.length > 0) {
      this.tienetag = true;
    } else {
      this.tienetag = false;
    }
  }
  public esconder() {
    this.otherTiendasresult = this.tiendasfil;
    this.sinletra = !this.sinletra;
  }
  private ordenarletras(listaTiendas) {
    for (const tienda of listaTiendas) {
      const letra = tienda.nombre[0];
      if (this.listaletras.indexOf(letra) === -1) {
        this.listaletras.push(letra);
      }
    }
  }
  public sortByKey(array) {
    return array.sort((a, b) => {
      const x = a.nombre;
      const y = b.nombre;
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
  public filtrar_categorias(subcategoria) {

  if (this.categoriactual !== subcategoria.nombre) {

         this.categoriactual = subcategoria.nombre;
         const listatiendasfiltradas = [];
         for (const suca of subcategoria.tiendas) {
               listatiendasfiltradas.push(suca);
         }
         this.otherTiendasresult = listatiendasfiltradas;
         this.enviarEventoFiltro(subcategoria.nombre);

      } else {
        this.categoriactual = '';
        this.otherTiendasresult = this.tiendasfil;
        this.enviarEventoFiltro('sin-categoria');
      }
  }

  public presionartecla(letra) {
    const listatiendas = [];
    for (const tienda of this.tiendasfil) {
      const primera = tienda.nombre[0];
      if (primera === letra) {
        listatiendas.push(tienda);
      }
    }
    this.otherTiendasresult = listatiendas;
  }

  public enviarEventoFiltro(categoria) {
    this.googleAnalyticsService.eventEmitter(
      'tiendas',
      'filter',
      categoria
    );
  }
  // logica de reinicio
  scrollevent = (event: any): void => {
    this.cancelartimer();
  }
  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }
  eliminarDiacriticos(texto) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  eliminartienda(tiendasporfiltrar: any, tiendasfiltradas: any) {
    for (const tienda of tiendasfiltradas ) {
      if (tiendasporfiltrar.indexOf(tienda)) {
        const ubicacion = tiendasporfiltrar.indexOf(tienda);
        tiendasporfiltrar.splice( ubicacion, 1 );
      }
    }
    return tiendasporfiltrar;
  }
}
